module.exports = __webpack_public_path__ + "df52a3517ea068d1374bf903ebef58db.pdf";